export default __webpack_public_path__ + "static/media/amazon.ad89fde0.svg";